import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpacierArcadeParsedGameData} from "./SpacierArcadeParsedGameData";
import {SpacierArcadeGameMode} from "../../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeParsedInitData} from "./SpacierArcadeParsedInitData";


export class SpacierArcadeModeData {
    get nextMode():string {
        return this._nextMode;
    }

    get mode():string {
        return this._mode;
    }

    public static instance:SpacierArcadeModeData = new SpacierArcadeModeData();

    private _mode:string;
    private _nextMode:string;
    private  _overlaySymbolsBeforeSpin:string[][];
    private  _newOverlaySymbols:string[][];
    private _isRestore:boolean;
    constructor() {

        this.addEventListeners();
    }

    private addEventListeners() {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onGameDataParsed(data:SpacierArcadeParsedGameData):void {
        this._isRestore = false;
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._overlaySymbolsBeforeSpin = data.overlaySymbolsBeforeSpin;
        this._newOverlaySymbols = data.newOverlaySymbols;
    }

    private onInitDataParsed(data:SpacierArcadeParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._overlaySymbolsBeforeSpin = data.overlaySymbols;
        this._newOverlaySymbols = data.overlaySymbols;
    }

    get isRestore():boolean{
        return this._isRestore;
    }

    get isMainGame():boolean{
        return this.mode === SpacierArcadeGameMode.RESPIN || this.mode === SpacierArcadeGameMode.NORMAL;
    }

    get isNextMainGame():boolean{
        return this.nextMode === SpacierArcadeGameMode.RESPIN || this.nextMode === SpacierArcadeGameMode.NORMAL;
    }

    get isFreespin():boolean{
        return this.mode === SpacierArcadeGameMode.FREESPIN_RESPIN || this.mode === SpacierArcadeGameMode.FREESPIN;
    }

    get isNextFreespin():boolean{
        return this.nextMode === SpacierArcadeGameMode.FREESPIN_RESPIN || this.nextMode === SpacierArcadeGameMode.FREESPIN;
    }

    get isRespin():boolean{
        return this.mode === SpacierArcadeGameMode.FREESPIN_RESPIN || this.mode === SpacierArcadeGameMode.RESPIN;
    }

    get isNextRespin():boolean{
        return this.nextMode === SpacierArcadeGameMode.FREESPIN_RESPIN || this.nextMode === SpacierArcadeGameMode.RESPIN;
    }

    get overlaySymbolsBeforeSpin():string[][]{
        return this._overlaySymbolsBeforeSpin;
    }

    get newOverlaySymbols():string[][]{
        return this._newOverlaySymbols;
    }
}